import React, { useCallback, useContext } from 'react';
import PropTypes from 'prop-types';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import metadata from './CoveragesComponent.metadata.json5';
import styles from '../../Policies/Summary/Summary.module.scss';
import {formatNumber, formatCurrency, NumberValue} from "@jutro/components";
import { IntlContext } from '@jutro/locale';

const getLimitDeductible = (items, property, intl) => {
    let amount = '-';
    let valueType='';
    if (items?.terms?.length > 0) {
        items.terms.forEach((term) => {
            if (term?.modelType?.toUpperCase() === property.toUpperCase() ||
                term?.name?.toUpperCase() === property.toUpperCase()) {
                amount = term.amount ? term.amount : term.chosenTermValue;
                valueType=term.valueType;
            }
        });
    }
    //return trimCharsAnsSpecialChars(amount) || amount;
    if(valueType == 'shorttext'){
        return (<span>
                {amount}
            </span>)
    }
    return formatNumber(intl, { format: 'decimal', showFractions: true}, trimCharsAnsSpecialChars(amount));
};

const getCellCoverageName = (rowData) => {
    return (
        <span>
            {rowData.name}
        </span>
    );
};

const getCellCoverageLimit = (rowData, intl) => {
    if (_.isEmpty(rowData.limit)) {
        return (
            <span>
                {getLimitDeductible(rowData, 'Limit', intl)}
            </span>
        );
    }
    else {
        const formattedLimit = formatNumber(intl, { format: 'decimal', showFractions: true}, trimCharsAnsSpecialChars(rowData.limit));
        return (
            <span>
                {formattedLimit}
            </span>
        );
    }
};

const getCellCoverageDeductible = (rowData, intl) => {
    if (_.isEmpty(rowData.deductible)) {
        return (
            <span>
                {getLimitDeductible(rowData, 'Deductible', intl)}
            </span>
        );
    }
    else {
        const formattedDeductible = formatNumber(intl, { format: 'decimal', showFractions: true}, trimCharsAnsSpecialChars(rowData.deductible));
        return (
            <span>
                {formattedDeductible}
            </span>
        );
    }
};

const getCellPremium = (rowData, rowIndex, intl) => {
    let premiumValue = rowData.premium ? rowData.premium : rowData.amount;

    if (premiumValue) {
        return (
           <b>{
               premiumValue.amount ?
                   <NumberValue
                       format="decimal"
                       id={`premium_${rowIndex}`}
                       maximumFractionDigits={2}
                       placeholder="-"
                       showFractions
                       suffix=".00"
                       tag="span"
                       value={premiumValue.amount}
                   />
                   :
                   <span>-</span>
           }
           </b>
        );

    }else { return <b> {<span>-</span>} </b>}
};

const trimCharsAnsSpecialChars = (userText) => {
    var regExpr = /[^0-9 ]/g;
    return userText.replace(regExpr, '');
}

function CoveragesComponent(props) {
    const intl = useContext(IntlContext);
    const { value: coveragesData } = props;
    const generateCoverageTableOverrides = useCallback(() => {
        return {
            coverageColumn: { onCell: getCellCoverageName },
            limitColumn: { onCell: (rowData) => {return getCellCoverageLimit(rowData, intl)} },
            deductibleColumn: { onCell: (rowData) => {return getCellCoverageDeductible(rowData, intl)} },
            premiumColumn: { onCell: (rowData, _index) => {return getCellPremium(rowData, _index, intl) }}
        };
    }, [coveragesData]);

    const overrideProps = {
        /* '@field': {
            labelPosition: 'left'
        }, */
        policyCoveragesTable: {
            data: coveragesData
        },
        ...generateCoverageTableOverrides()
    };

    const resolvers = {
        resolveClassNameMap: styles
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={coveragesData}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

CoveragesComponent.propTypes = {
    value: PropTypes.shape({}).isRequired
};

export default CoveragesComponent;
